<template>
<div class="frontpage">
  <img alt="Logo" src="../../assets/images/logo.png"/>
  <div id="nav" class="transparent">
    <router-link to="/auth/forgot-password">Forgot password</router-link>
  </div>
</div>
</template>


<script>
export default { }
</script>

<style lang="scss">
div.frontpage {
    background: url("../../assets/images/background.svg");
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover!important;
    padding-top: 30vh;
    color: white;
    
    #nav {
        a {
            padding: 0.5em;
            color: #ECECEC;
            text-decoration: none;
            &:hover {
		text-decoration: underline;
            }
        }
	
    }

    .transparent {
	background-color: unset!important;
    }
}


</style>
